export enum OriginActionName {
    ComponentReady = 'ComponentReady',
    LogOff = 'LogOff',
    ContractEdit = 'ContractEdit',
    ContractCancel = 'ContractCancel',
    CapturePayment = 'CapturePayment',
    CustomerSelected = 'CustomerSelected',
    PorPayResponse = 'PorPayResponse',
    QuoteSubmit = 'QuoteSubmit'
}
